import React from "react";
import { StyledForm } from "./index.styled";

export type AppFormContainerProps = {
  labelCol?: { span: number };
  wrapperCol?: { span: number };
  children: React.ReactNode;
  [x: string]: any;
};

const defaultValidateMessages = {
  required: '${label} is required',
};

const AppFormContainer: React.FC<AppFormContainerProps> = ({
  labelCol = { span: 8 },
  wrapperCol = { span: 16 },
  children,
  validateMessages,
  ...rest
}: AppFormContainerProps) => {

 return (
    <StyledForm
      name="basic"
      labelCol={labelCol}
      wrapperCol={wrapperCol}
      // initialValues={{ remember: true }}
      autoComplete="off"
      validateMessages={{ ...defaultValidateMessages, ...validateMessages }}
       {...rest}
    >
      {children}
    </StyledForm>
 )
};
export default AppFormContainer;
